import {Steps} from "../constants/constants";

const StepOverview = ({step}) => {

    if (step === Steps.CONFIRMED) {
        return null
    }

    return (
        <div className="c-repair-form-steps">
            <div className={'c-repair-form-steps__step' + (step === Steps.LOCATION ? " is-active" : "")}>
                <span className="c-repair-form-steps__step__text">Locatiegegevens</span>
            </div>
            <div className={"c-repair-form-steps__step" + (step === Steps.REPORT_DATA ? " is-active" : "")}>
                <span className="c-repair-form-steps__step__text">Meldingsgegevens</span>
            </div>
            <div className={"c-repair-form-steps__step" + (step === Steps.CONFIRM ? " is-active" : "")}>
                <span className="c-repair-form-steps__step__text">Bevestigen</span>
            </div>
        </div>
    )
}
export default StepOverview